/**
 * AdminRoute — route guard for admin-only pages. Non-admins are
 * bounced to /dashboard so the route behaves like it doesn't exist.
 * The backend still enforces authorization via the "admins" group
 * check; this guard is purely UX.
 */
import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { isAdmin } from './auth';
import { useAuth } from './AuthContext';

export default function AdminRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <p style={{ padding: 'var(--sp-6)' }}>Loading…</p>;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (!isAdmin(user)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
